"use client";

import { useCart } from "./CartContext";

export default function ToastContainer() {
  const { toasts, dismissToast } = useCart();

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 60,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        pointerEvents: "none",
      }}
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="animate-slide-up"
          style={{
            pointerEvents: "auto",
            display: "grid",
            gridTemplateColumns: "auto 1fr auto",
            gap: 12,
            alignItems: "center",
            background: "var(--bp-ink)",
            color: "var(--bp-bg)",
            padding: "14px 18px",
            border: "1px solid var(--bp-ink)",
            maxWidth: 360,
          }}
        >
          <span
            className="bp-mono-sm"
            style={{ color: "var(--bp-bg)", letterSpacing: "0.2em" }}
          >
            ✓ ADDED
          </span>
          <span style={{ fontFamily: "var(--bp-serif)", fontSize: 16, fontWeight: 300, lineHeight: 1.25 }}>
            {toast.productName}
          </span>
          <button
            onClick={() => dismissToast(toast.id)}
            aria-label="Dismiss"
            className="bp-mono-sm"
            style={{
              color: "oklch(0.72 0 0)",
              background: "none",
              border: 0,
              cursor: "pointer",
              padding: "0 4px",
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
